export {
  useGetApplications,
  ApplicationInformation
} from './useGetApplications';
